export const DEFAULT_CHECKOUT_LOADER_MESSAGE = 'Processing your purchase...';
export const BANK_AUTHENTICATION_LOADER_MESSAGE =
  'Confirming payment with your bank…';

export function resolveCheckoutLoaderMessage(
  authenticationMessage: string,
): string {
  return authenticationMessage || DEFAULT_CHECKOUT_LOADER_MESSAGE;
}

export function authenticationMessageForRequiresAction(
  requiresAuthentication?: boolean,
): string {
  return requiresAuthentication ? BANK_AUTHENTICATION_LOADER_MESSAGE : '';
}
